import { PrivateSpace } from '@weblite/ts-action/private-space'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'private-space'

export const privateSpaceStorage = createKeyvalStorage<PrivateSpace>(key)

export const privateSpaceView = createKeyvalView<PrivateSpace>(key)
